export const STORAGE_KEY = 'motec_dashboard'
